import { render, staticRenderFns } from "./editeNotifiaction.vue?vue&type=template&id=163c57a2"
import script from "./editeNotifiaction.vue?vue&type=script&lang=js"
export * from "./editeNotifiaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports